import React from "react";
import { navigate } from "gatsby";

const Lazy404 = React.lazy(() => import("../pages/404"));

class GlobalErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[GlobalErrorBoundary]", error, errorInfo);
    }
    if (typeof window !== "undefined" && window.location.pathname !== "/404") {
      navigate("/404", { replace: true });
    }
  }

  componentDidUpdate() {
    if (typeof window === "undefined") return;
    const on404 = window.location.pathname === "/404";
    if (this.state.hasError && on404) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Suspense fallback={null}>
          <Lazy404 />
        </React.Suspense>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
